<div class="flex flex-col gap-4" #soccerMatchesContainer>
  @if(teamMatchesPast()!== null && teamMatchesPast()!.length > 0){
  <!--  -->
  <div class="mt-3 font-roboto-500 text-18 max-sm:text-14 mb-2">
    {{ "LastMatches" | translate }}
  </div>

  @for (competitionByDate of teamMatchesPast(); track $index) {
  <!--  -->
  @if(isNextMatches(competitionByDate.date) ) {
  <app-date-label [matchDate]="competitionByDate.date" />
  }
  <!--  -->

  @for (competition of competitionByDate.competitions; track $index) {

  <app-competition-by-team-row [data]="competition" entity="Competition" />
  } }

  <!--  -->
  } @else {
  <!--  -->
  @if(!fetchComputed().isLoading){

  <app-no-result message="NotAvalaibleInformation" />
  } }
</div>

<div #scrollTrigger style="height: 1px"></div>

<!-- Case Loading -->
@if(fetchComputed().isLoading){
<app-skeleton-matches-list />
}

<!-- Case Error -->
@if((fetchComputed().isError && !fetchComputed().isLoading) ){
<app-no-result message="NotAvalaibleInformation" />
}
